import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';

function SignIn() {
    console.log("does anything log?");

            const [formData, setFormData] = useState({
              username: '',
              password: ''    
            });

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));

 
    };

    const navigate = useNavigate();
    const handleSubmit = async (event) => {
      event.preventDefault();

      //console.log(formData);


      try {
        const response = await fetch(process.env.REACT_APP_SIGN_IN_URL, {
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Connection': 'keep-alive'          },
          body: JSON.stringify(formData),
        });
  
        const data = await response.json();
  
        if (response.ok) {
          console.log(data);
          alert("success!");
          sessionStorage.setItem('idToken', data['AuthenticationResult']['IdToken']);
          sessionStorage.setItem('accessToken', data['AuthenticationResult']['AccessToken']);
          sessionStorage.setItem('refreshToken', data['AuthenticationResult']['RefreshToken']);
          navigate('/');
        } else {
          alert("error!");
        }
      } catch (error) {
        alert("Error occurred during request");
        console.log(error);
      }     
    };

 

      return (
    <div >
        
        <div className="page-header align-items-start min-height-300 m-3 border-radius-xl" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1491466424936-e304919aada7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1949&q=80')` }}  loading="lazy">
    <span className="mask bg-gradient-dark opacity-6"></span>
  </div>
  <div className="container mb-4">
    <div className="row mt-lg-n12 mt-md-n12 mt-n12 justify-content-center">
      <div className="col-xl-4 col-lg-5 col-md-7 mx-auto">
        <div className="card mt-8">
          <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div className="bg-gradient-success shadow-success border-radius-lg py-3 pe-1 text-center py-4">
              <h4 className="font-weight-bolder text-white mt-1">Sign In</h4>
              <p className="mb-1 text-sm text-white">Enter your email and password to Sign In</p>
            </div>
          </div>
          <div className="card-body">
            <form className="text-start" onSubmit={handleSubmit}>
              <div className="input-group input-group-static mb-4">
                <label>Email</label>
                <input type="email" className="form-control" placeholder="john@email.com" onChange={handleInputChange} id="username" name="username"/>
              </div>
              <div className="input-group input-group-static mb-4">
                <label>Password</label>
                <input type="password" className="form-control" placeholder="•••••••••••••" onChange={handleInputChange} id="password" name="password"/>
              </div>
              <div className="form-check form-switch d-flex align-items-center mb-3">
                <input className="form-check-input" type="checkbox" id="rememberMe" checked="" />
                <label className="form-check-label mb-0 ms-3" htmlFor="rememberMe">Remember me</label>
              </div>
              <div className="text-center">
                <button type="submit" className="btn bg-gradient-dark w-100 mt-3 mb-0">Sign in</button>
              </div>
            </form>
          </div>
          <div className="card-footer text-center pt-0 px-lg-2 px-1">
            <p className="mb-4 text-sm mx-auto">
              Don't have an account?
              <Link to="/signUp" className="text-success text-gradient font-weight-bold">Sign up</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  

        </div>
      );
    }
    
    export default SignIn;